(() => {
  'use strict';

  // Target the discount line inside Appstle's subscription option
  const DISCOUNT_SELECTOR =
    '.appstle_subscription_wrapper ' +
    '.appstle_input_wrapper.appstle_subscription_option > label ' +
    '.appstle_span_wrapper > .appstle_discount_block';

  function normalizeDiscountText(root = document) {
    const nodes = root.querySelectorAll(DISCOUNT_SELECTOR);
    nodes.forEach(node => {
      // don't keep rewriting the same node
      if (node.dataset.wellfNormalized === '1') return;

      const raw = (node.textContent || '').trim();
      const m = raw.match(/(\d+(?:\.\d+)?)\s*%/i); // capture "20" from "20% off", "(20% OFF)", etc.
      if (m) {
        node.textContent = `SAVE ${m[1]}%`;
        node.dataset.wellfNormalized = '1';
      }
    });
  }

  function init() {
    normalizeDiscountText();

    // Watch for Appstle re-renders (variant/plan changes, AJAX, etc.)
    const target =
      document.getElementById('appstle_subscription_widget0') ||
      document.querySelector('.appstle_subscription_wrapper') ||
      document.body;

    const mo = new MutationObserver(() => normalizeDiscountText());
    mo.observe(target, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
